<app-blog-shell [blogId]="'design-decision'" [darkMode]="darkMode">
  <div #entryRoot class="blog-entry">
    <h1 data-translate="BLOG.DETAILS.design-decision.TITLE"></h1>
    <br>

    <h2 data-translate="BLOG.DETAILS.design-decision.TLDR.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-decision.TLDR.BODY"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-decision.SECTION1.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-decision.SECTION1.P1"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-decision.SECTION2.HEADLINE"></h2>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.design-decision.SECTION2.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION2.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION2.ITEM3"></li>
    </ul>
    <p data-translate="BLOG.DETAILS.design-decision.SECTION2.P1"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-decision.SECTION3.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-decision.SECTION3.P1"></p>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.design-decision.SECTION3.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION3.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION3.ITEM3"></li>
    </ul>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-decision.SECTION4.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-decision.SECTION4.P1"></p>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.design-decision.SECTION4.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION4.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION4.ITEM3"></li>
    </ul>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-decision.SECTION5.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-decision.SECTION5.P1"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-decision.SECTION6.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-decision.SECTION6.P1"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-decision.SECTION7.HEADLINE"></h2>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.design-decision.SECTION7.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION7.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION7.ITEM3"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION7.ITEM4"></li>
      <li data-translate="BLOG.DETAILS.design-decision.SECTION7.ITEM5"></li>
    </ul>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-decision.CONCLUSION.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-decision.CONCLUSION.P1"></p>
    <p data-translate="BLOG.DETAILS.design-decision.CONCLUSION.P2"></p>
  </div>
  <br>
</app-blog-shell>
